export const JOB_PORTAL_URL = "https://job.agriyuvaa.com/";
export const EASE = [0.22, 1, 0.36, 1];
